import script from "./PopupBase.vue?vue&type=script&setup=true&lang=ts"
export * from "./PopupBase.vue?vue&type=script&setup=true&lang=ts"

import "./PopupBase.vue?vue&type=style&index=0&id=2bc92323&scoped=true&lang=sass"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2bc92323"]])

export default __exports__